import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCMi0IF4WevKQ1aRzwcITth2WJhJcI8jzE",
  authDomain: "qna-gpt.firebaseapp.com",
  projectId: "qna-gpt",
  storageBucket: "qna-gpt.appspot.com",
  messagingSenderId: "749436358273",
  appId: "1:749436358273:web:c7ad1485cb587492aec780",
  measurementId: "G-RN2334VP7K",
};

initializeApp(firebaseConfig);
